import mixpanel from 'mixpanel-browser';

// Only initialize Mixpanel in production
const isProduction = process.env.NODE_ENV === 'production';

if (isProduction && process.env.REACT_APP_MIXPANEL_TOKEN) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    api_host: 'https://api-eu.mixpanel.com',
    debug: false
  });
}

export const trackEvent = (eventName, properties = {}) => {
  try {
    // In development, just log to console
    if (!isProduction) {
      console.log('[Analytics - Dev]', eventName, properties);
      return;
    }

    mixpanel.track(eventName, {
      ...properties,
      environment: process.env.NODE_ENV,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('Mixpanel tracking error:', error);
  }
};

export const identifyUser = (userId, userProperties = {}) => {
  try {
    // In development, just log to console
    if (!isProduction) {
      console.log('[Analytics - Dev] Identify User:', userId, userProperties);
      return;
    }

    mixpanel.identify(userId);
    mixpanel.people.set({
      ...userProperties,
      $last_seen: new Date()
    });
  } catch (error) {
    console.error('Mixpanel identify error:', error);
  }
};

export const trackPageView = (pageName) => {
  trackEvent('Page View', { page: pageName });
};

export default mixpanel;
